<template>
    <apexchart type="bar" :height="height" :width="width" :options="options" :series="datasource.series"></apexchart>
</template>

<script>
import i18n from '@/i18n';

export default {
    name: "barColumnRotateLabelChart",
    props: {
        datasource: {
            type: Object,
            default: null
        },
        titleChart: {
            type: String,
            default: undefined
        },
        titleChartColor: {
            type: String,
            default: "#000"
        },
        showLegend: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: "100%"
        },
        height: {
            type: String,
            default: "100%"
        },
        plotOptionsBarDistributed: {
            type: Boolean,
            default: true
        },
        chartStacked: {
            type: Boolean,
            default: false
        },
        columnWidth: {
            type: String,
            default: "80%"
        },
        yaxisShow: {
            type: Boolean,
            default: false
        },
        yaxisZeroLine: {
            type: Boolean,
            default: false
        },
        dataValuesWithPercentSymbol: {
            type: Boolean,
            default: false
        },
        dataLabelsPercentValues: {
            type: Boolean,
            default: false
        },
        dataLabelsPercentValuesHideSymbol: {
            type: Boolean,
            default: false
        },
        dataLabelsFontSize: {
            type: Number,
            default: 12
        },
        xaxisLabelsFontSize: {
            type: Number,
            default: 11
        },
        xaxisLabelsTrim: {
            type: Boolean,
            default: false
        },
        xaxisLabelsTrimRotateAlways: {
            type: Boolean,
            default: false
        },
        ifValueBelowThresholdBool: {
            type: Boolean,
            default: false
        },
        ifValueHigherThresholdBool: {
            type: Boolean,
            default: false
        },
        valueThreshold: {
            type: Number,
            default: 100
        }
    },
    data: () => ({

    }),
    computed: {
        options() {
            return {
                title: {
                    text: this.titleChart,
                    align: 'center',
                    margin: 20,
                    style: {
                        fontSize: '22px',
                        fontWeight: '400',
                        color: this.titleChartColor
                    }
                },
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: false,
                    },
                    stacked: this.chartStacked
                },
                plotOptions: {
                    bar: {
                        //borderRadius: 7,
                        columnWidth: this.columnWidth,
                        dataLabels: {
                            position: 'top',
                        },
                        distributed: this.plotOptionsBarDistributed
                    }
                },
                dataLabels: {
                    enabled: true,
                    offsetY: this.dataLabelsPercentValues ? -58  : -20,
                    style: {
                        fontSize: this.dataLabelsFontSize + 'px',
                        colors: [
                            ({ seriesIndex, dataPointIndex,  w }) => {
                                let valueItemData = w.config.series[seriesIndex].data[dataPointIndex];
                                if(this.dataLabelsPercentValues){
                                    let percentItemData = w.config.series[seriesIndex].percentData[dataPointIndex];
                                    if (percentItemData.includes('+')) {
                                        return "#43A047";
                                    } else if (percentItemData.includes('-')) {
                                        return "#f44336";
                                    } else {
                                        return "rgba(0,0,0,0.6)"
                                    }
                                } else if(this.ifValueBelowThresholdBool && Number(valueItemData) < this.valueThreshold){
                                    return "#f44336";
                                } else if(this.ifValueHigherThresholdBool && Number(valueItemData) > this.valueThreshold){
                                    return "#43A047";
                                }
                                else{
                                    return "rgba(0,0,0,0.6)";  
                                }
                            }
                        ]
                    },
                    formatter: (value, { seriesIndex, dataPointIndex }) => {
                        if(this.dataValuesWithPercentSymbol){
                            if(value == null){
                                return i18n.t('Поручений_нет');
                            }
                            return value + '%';
                        }
                        let result = Math.abs(value);
                        if(this.dataLabelsPercentValues){
                            let percentData = this.datasource.series[seriesIndex].percentData[dataPointIndex];
                            if(percentData == ""){
                                percentData = "0%"
                            }
                            if(this.dataLabelsPercentValuesHideSymbol){
                                percentData = percentData.split(/[-+]/).join("");
                            }
                            return [percentData, result];
                        }else{
                            return result;
                        }    
                    },
                    dropShadow: {
                        enabled: false,
                    } 
                },
                stroke: {
                    width: 0
                },
                yaxis: {
                    show: this.yaxisShow,
                    /*min: (min) => {
                        return Math.floor(min * 1.2 / 10) * 10;
                    },
                    max: (max) => {
                        return Math.ceil(max * 1.2 / 10) * 10;
                    },*/
                    labels: {
                        style: {
                            colors: ['#fff'],
                            fontSize: '14px',
                            fontWeight: 'normal'
                        }
                    },
                    axisBorder: {
                        show: true,
                        color: '#4f4e4c'
                    },
                    axisTicks: {
                        show: true,
                        color: '#4f4e4c'
                    }
                },
                xaxis: {
                    categories: this?.datasource?.categories,
                    labels: {
                        style: {
                            //colors: Array(this?.datasource?.categories?.length).fill('#000'),
                            fontSize: this.xaxisLabelsFontSize + 'px'
                        },
                        rotate: -45,
                        rotateAlways: this.xaxisLabelsTrimRotateAlways,
                        //trim как ни странно, этот параметр влияет на ширину чарта, если вдруг она меньше то делаем true
                        trim: this.xaxisLabelsTrim,
                    },
                    axisBorder: {
                        show: true,
                        color: '#4f4e4c'
                    },
                    axisTicks: {
                        show: true,
                        color: '#4f4e4c'
                    }
                },
                grid: {
                    show: false,
                    padding: {
                        top: -15,
                        bottom: 27
                    }
                },
                annotations: {
                    yaxis: [{
                        y: 0,
                        borderColor: this.yaxisZeroLine ? '#4f4e4c' : 'transparent',
                        fillColor: '#4f4e4c',
                        borderWidth: 2,
                        strokeDashArray: 0
                    }]
                },
                colors: this?.datasource?.colors,
                legend: {
                    show: this.showLegend,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    labels: {
                        useSeriesColors: true
                    }
                },
                tooltip: {
                    shared: false,
                    custom: ({ series, seriesIndex, dataPointIndex, w}) => {
                        let seriesName = w.globals.labels[dataPointIndex];
                        let value = Math.abs(series[seriesIndex][dataPointIndex]);
                        if(this.dataLabelsPercentValues){
                            let percentData = this.datasource.series[seriesIndex].percentData[dataPointIndex];
                            value = value + ' (' + percentData + ')';
                        }
                        if(this.dataValuesWithPercentSymbol){
                            value = value + '%';  
                        }
                        let color = '#444';
                        if(series.length == 1){
                            color = w.config.colors[dataPointIndex];
                        }else if(series.length > 1){
                            color = w.config.colors[seriesIndex];
                        }
                        return `
                            <div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex; background-color: ${color};">
                                <div class="apexcharts-tooltip-text" style="font-size:12px;color:#fff">
                                    <div class="apexcharts-tooltip-y-group">
                                        <span class="apexcharts-tooltip-text-y-label">${seriesName}: </span>
                                        <span class="apexcharts-tooltip-text-y-value">${value}</span>
                                    </div>
                                </div>
                            </div>`;
                    }
                },
                fill: {
                    type: 'solid',
                    gradient: {
                        shade: 'light',
                        type: "horizontal",
                        shadeIntensity: 0.25,
                        gradientToColors: undefined,
                        inverseColors: true,
                        opacityFrom: 0.85,
                        opacityTo: 0.85,
                        stops: [50, 0, 100]
                    },
                }
            }
        }
    }
}
</script>